// extracted by mini-css-extract-plugin
export var items_content = "HomeFeatured-module--items_content--k43kM";
export var home_item = "HomeFeatured-module--home_item--ZdRA3";